import 'core-js/stable';
import 'regenerator-runtime/runtime';
import FontFaceObserver from 'fontfaceobserver';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app';

const MOUNT_NODE = document.getElementById('app');

const render = () => {
  createRoot(MOUNT_NODE).render(<App />);
};

const montserrat = new FontFaceObserver('Montserrat');
const openSans = new FontFaceObserver('Open Sans');
const muoto = new FontFaceObserver('Muoto');

// eslint-disable-next-line @typescript-eslint/no-floating-promises
Promise.all([montserrat.load(), openSans.load(), muoto.load()])
  .finally(() => {
    render();
  });
